module.exports = __webpack_public_path__ + "media/images/emblems/Grueningen-blazon-3959dc6d029b1e976c79fdc842a66ac6.svg";